module.exports = __webpack_public_path__ + "static/media/search-go-icon.265db31b.svg";